import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicTable, BaasicButton } from "core/components";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";
import { isSome } from "core/utils";

const DressingRuleListTemplate = function({ dressingRuleListViewStore }) {
    
    const { 
        tableStore, 
        routes,
        authorization} = dressingRuleListViewStore;

    return (
        <ApplicationListLayout
            store={dressingRuleListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton className="btn btn--base btn--primary"  label={'New dressing rule'} onClick={() => routes.create()} authorized={authorization ? authorization.create : true}></BaasicButton>
            </PageNavigation>
            <Content>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

DressingRuleListTemplate.propTypes = {
    dressingRuleListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const{
        onEdit,
        onDelete
    } = actions;
    
    if(!isSome(onEdit) && !isSome(onDelete))
    {
        return null;
    } 

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEdit) ? (
                    <BaasicButton
                    authorization={
                        authorization ? authorization.update : null
                    }
                    className="btn btn--icon"
                    icon="u-icon u-icon--edit u-icon--sml"
                    label="Edit"
                    onlyIcon={true}
                    onClick={() => onEdit(item)}
                ></BaasicButton>
                ) : null         
            }
            {isSome(onDelete) ? (
                <BaasicButton
                    authorization={authorization ? authorization.update : null}
                    className="btn btn--icon"
                    icon = 'u-icon--delete u-icon--sml'
                    label ='Delete dressing rule'
                    onlyIcon={true}
                    onClick={() => onDelete(item)}>
                </BaasicButton>
            ) : null}
            </div>
        </td>
    )
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(DressingRuleListTemplate);